/**
 * Loose object guard: any non-null object, arrays included. The complement of
 * `isRecord` (lib/shared/guards/is-record.ts), which rejects arrays. Use it
 * where the payload is an untyped JSON envelope whose arrays must pass —
 * the site-factory handlers, the app-error decoder, the retry classifier,
 * the brand normalizer. Convex-reachable leaf: no imports.
 */
export function isObjectLike(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}
